(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\main.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _svgInjector = require('./modules/svgInjector');

var _parallax = require('./modules/parallax');

var _imagePopUp = require('./modules/imagePopUp');

var _carousels = require('./modules/carousels');

var _miniGallery = require('./modules/miniGallery');

var _cookies = require('./modules/cookies');

var _scrollTo = require('./modules/scrollTo');

var _googleMaps = require('./modules/googleMaps');

var _video = require('./modules/video');

var _validator = require('./modules/validator');

var _sidePanel = require('./modules/sidePanel');

var _visible = require('./modules/visible');

var _switches = require('./modules/switches');

var _countdown = require('./modules/countdown');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import {Load}             from './modules/load';

var svgInjector = new _svgInjector.SvgInjector();
var parallax = new _parallax.Parallax();
var imagePopUp = new _imagePopUp.ImagePopUp();
var carousels = new _carousels.Carousels();
var miniGallery = new _miniGallery.MiniGallery();
var cookies = new _cookies.Cookies();
var scrollTo = new _scrollTo.ScrollTo();
var googleMaps = new _googleMaps.GoogleMaps();
var video = new _video.Video();
var validator = new _validator.Validator();
var sidePanel = new _sidePanel.SidePanel();
var visible = new _visible.Visible();
var switches = new _switches.Switches();
var countdown = new _countdown.Countdown();
// var load              = new Load();

var Main = function () {
  function Main(node_env) {
    _classCallCheck(this, Main);

    this.node_env = node_env;
    this.sections = $('.cms-section');
  }

  _createClass(Main, [{
    key: 'bootstrap',
    value: function bootstrap(callback) {
      var $sections = $(this.sections);
      this.modules($sections);
      this.responsiveModules($sections);
      callback();
    }
  }, {
    key: 'modules',
    value: function modules($sections) {
      parallax.init($sections);
      svgInjector.init();
      imagePopUp.init();
      carousels.init();
      miniGallery.init();
      cookies.init();
      scrollTo.init();
      googleMaps.init();
      video.init();
      validator.init();
      sidePanel.init();
      visible.init();
      switches.init();
      countdown.init();
      // load.init();
    }
  }, {
    key: 'responsiveModules',
    value: function responsiveModules($sections) {
      $(window).resize(function () {
        parallax.init($sections);
        carousels.init();
        miniGallery.init();
      });

      $(window).scroll(function () {
        $('.video-player').each(function (id, videoPlayer) {
          if ($(videoPlayer).visible(true)) {
            video.play($(videoPlayer));
          } else {
            video.stop($(videoPlayer));
          }
        });
      });
    }
  }]);

  return Main;
}();

$(window).load(function () {
  var main = new Main('development');
  main.bootstrap(function () {
    $('#page-overlay').fadeOut(800);
  });
  $('.btn-mystic-2019').on('click', function () {
    $('.popup2020').fadeOut();
  });
});

var lazyLoadInstance = new LazyLoad({
  elements_selector: ".lazy"
});

},{"./modules/carousels":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\carousels.js","./modules/cookies":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\cookies.js","./modules/countdown":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\countdown.js","./modules/googleMaps":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\googleMaps.js","./modules/imagePopUp":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\imagePopUp.js","./modules/miniGallery":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\miniGallery.js","./modules/parallax":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\parallax.js","./modules/scrollTo":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\scrollTo.js","./modules/sidePanel":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\sidePanel.js","./modules/svgInjector":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\svgInjector.js","./modules/switches":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\switches.js","./modules/validator":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\validator.js","./modules/video":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\video.js","./modules/visible":"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\visible.js"}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\carousels.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Carousels = exports.Carousels = function () {
    function Carousels() {
        _classCallCheck(this, Carousels);
    }

    _createClass(Carousels, [{
        key: 'init',
        value: function init() {
            var carouselThumbs = $('.gallery-thumbs .owl-carousel, .article-list__slider .owl-carousel, .slider .owl-carousel'),
                carouselZoom = $('.gallery-category--zoom-slider .owl-carousel'),
                pluginFlag = carouselThumbs.length || carouselZoom.length;

            if (pluginFlag) if (carouselThumbs) this.carouselThumbs(carouselThumbs);
            if (carouselZoom) this.carouselZoom(carouselZoom);
        }
    }, {
        key: 'carouselThumbs',
        value: function carouselThumbs(carousel) {
            carousel.owlCarousel({
                items: 1,
                loop: true,
                margin: 0,
                nav: true,
                navText: ['<i class="fa fa-arrow-circle-o-left"></i>', '<i class="fa fa-arrow-circle-o-right"></i>'],
                dots: false,
                thumbs: true,
                autoplay: typeof carousel.data('autoplay') !== 'undefined' ? carousel.data('autoplay') : false,
                thumbsPrerendered: true,
                onChanged: function onChanged(e) {
                    var itemsLength = this._items.length;

                    var $slider = this.$element.closest('.slider'),
                        $slides = $slider.find('.owl-carousel .owl-item:not(.cloned)'),
                        $thumbsContainer = $slider.find('.slider-thumbs'),
                        $thumbsList = $slider.find('.owl-thumbs');

                    var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
                        thumbsListWidth = thumbWidth * itemsLength,
                        thumbsContainerWidth = $thumbsContainer.width();

                    var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
                        thumbsPositionPart = thumbsOuterWidth / itemsLength;

                    var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
                        currentSlide = $slides.eq(currentPosition);

                    var firstMarginLeft = parseInt($thumbsList.find('.owl-thumb-item').first().css('margin-left')),
                        lastMarginRight = parseInt($thumbsList.find('.owl-thumb-item').last().css('margin-right'));

                    var offset = currentPosition === 0 ? -firstMarginLeft : currentPosition === itemsLength - 1 ? thumbsContainerWidth - thumbsListWidth + lastMarginRight : (-currentPosition + 1) * thumbsPositionPart - firstMarginLeft;

                    if (thumbsOuterWidth <= 0) {
                        $thumbsList.css({
                            '-webkit-transform': 'translateX(' + -firstMarginLeft + 'px)',
                            '-mox-transform': 'translateX(' + -firstMarginLeft + 'px)',
                            'transform': 'translateX(' + -firstMarginLeft + 'px)'
                        });
                    } else if (thumbsOuterWidth > 0) {
                        $thumbsList.css({
                            '-webkit-transform': 'translateX(' + offset + 'px)',
                            '-mox-transform': 'translateX(' + offset + 'px)',
                            'transform': 'translateX(' + offset + 'px)'
                        });
                    }

                    setTimeout(function () {
                        currentSlide.addClass('active');
                    });
                }
            });
        }
    }, {
        key: 'carouselZoom',
        value: function carouselZoom(carousel) {
            carousel.owlCarousel({
                stagePadding: 40,
                loop: true,
                autoWidth: false,
                center: true,
                margin: 0,
                responsive: {
                    0: {
                        items: 3,
                        autoWidth: true
                    },
                    320: {
                        items: 3
                    },
                    641: {
                        items: 3,
                        autoWidth: true,
                        center: false
                    },
                    1024: {
                        items: 4,
                        center: true,
                        autoWidth: true
                    },
                    1350: {
                        items: 7,
                        center: true,
                        autoWidth: true
                    }
                }
            });

            carousel.find('.owl-item').on('click', function () {
                var $this = $(this),
                    index = $this.index(),
                    itemsLength = $this.siblings('.owl-item').length,
                    itemsHandler = $this.closest('.owl-stage-outer'),
                    activeItems = $this.closest('.gallery-category--zoom-slider').find('.active');

                if ($this.hasClass('zoomed')) {
                    $this.removeClass('zoomed');
                } else if ($this.prev().hasClass('active') && $this.next().hasClass('active') || !$this.prev().hasClass('active') && !$this.next().hasClass('active')) {
                    $('.zoomed').removeClass('zoomed');
                    $this.addClass('zoomed');
                } else if ($this.prev().hasClass('active') && !$this.next().hasClass('active')) {
                    carousel.trigger('next.owl.carousel', [500]);
                    $('.zoomed').removeClass('zoomed');
                    $this.addClass('zoomed');
                } else if (!$this.prev().hasClass('active') && $this.next().hasClass('active')) {
                    carousel.trigger('prev.owl.carousel', [500]);
                    $('.zoomed').removeClass('zoomed');
                    $this.addClass('zoomed');
                }
            });
        }
    }]);

    return Carousels;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\cookies.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = exports.Cookies = function () {
	function Cookies() {
		_classCallCheck(this, Cookies);
	}

	_createClass(Cookies, [{
		key: 'init',
		value: function init() {
			var self = this;
			$(document).ready(function () {

				if (self.getCookie("cookie_agree") == 1) {
					$('.cookies-tab').hide();
				} else {
					$('.cookies-tab').fadeIn(500);
				}

				$('.cookies-tab .button').click(function () {
					self.cookieAgree();
					return false;
				});
			});
		}
	}, {
		key: 'cookieAgree',
		value: function cookieAgree() {
			var self = this;
			self.setCookie("cookie_agree", 1, 365);
			$('.cookies-tab').fadeOut(400);
		}
	}, {
		key: 'getCookie',
		value: function getCookie(name) {
			var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
			return v ? v[2] : null;
		}
	}, {
		key: 'setCookie',
		value: function setCookie(name, value, days) {
			var d = new Date();
			d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
			document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
		}
	}]);

	return Cookies;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\countdown.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Countdown = exports.Countdown = function () {
	function Countdown() {
		_classCallCheck(this, Countdown);
	}

	_createClass(Countdown, [{
		key: "init",
		value: function init() {
			var countDownDate = new Date("Jun 25, 2019 15:30:00").getTime();

			// Update the count down every 1 second
			if (document.getElementById("countdown") !== null) {
				var x = setInterval(function () {

					// Get today's date and time
					var now = new Date().getTime();

					// Find the distance between now and the count down date
					var distance = countDownDate - now;

					// Time calculations for days, hours, minutes and seconds
					var days = Math.floor(distance / (1000 * 60 * 60 * 24));
					var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
					var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
					var seconds = Math.floor(distance % (1000 * 60) / 1000);

					// Display the result in the element with id="demo"
					document.getElementById("countdown").innerHTML = "<span class='h2 d-block '>" + days + "d " + hours + "h " + minutes + "m " + seconds + "s </span>";

					// If the count down is finished, write some text
					if (distance < 0) {
						clearInterval(x);
						document.querySelectorAll(".countdown-container")[0].style.display = "none";
						document.querySelectorAll(".countdown-container")[0].remove();
					}
				}, 1000);
			}
		}
	}]);

	return Countdown;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\googleMaps.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMaps = exports.GoogleMaps = function () {
	function GoogleMaps() {
		_classCallCheck(this, GoogleMaps);
	}

	_createClass(GoogleMaps, [{
		key: 'init',
		value: function init() {
			var self = this;
			if ($('.google-map').length) {
				$(document).ready(function () {
					self.geocode();
				});
			}
		}
	}, {
		key: 'geocode',
		value: function geocode() {
			$('.google-map').each(function (id, mapSection) {
				var address = $(mapSection).data('address'),
				    mapContent = $(mapSection).find('.google-map__content').attr('id');
				var mapOptions = {
					zoom: 15,
					center: new google.maps.LatLng(40.6700, -73.9400),
					styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
				};

				var mapElement = document.getElementById(mapContent);

				var map = new google.maps.Map(mapElement, mapOptions);
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'address': address }, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						map.setCenter(results[0].geometry.location);
						var marker = new google.maps.Marker({
							map: map,
							position: results[0].geometry.location
						});
					}
				});
			});
		}
	}]);

	return GoogleMaps;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\imagePopUp.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImagePopUp = exports.ImagePopUp = function () {
    function ImagePopUp() {
        _classCallCheck(this, ImagePopUp);
    }

    _createClass(ImagePopUp, [{
        key: 'init',
        value: function init() {
            $('.picture a, .image a').magnificPopup({
                type: 'image',
                closeOnContentClick: true,
                closeBtnInside: false,
                fixedContentPos: true,
                mainClass: 'mfp-no-margins mfp-with-zoom',
                image: {
                    verticalFit: true
                },
                zoom: {
                    enabled: true,
                    duration: 300
                }
            });
        }
    }]);

    return ImagePopUp;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\miniGallery.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MiniGallery = exports.MiniGallery = function () {
    function MiniGallery() {
        _classCallCheck(this, MiniGallery);
    }

    _createClass(MiniGallery, [{
        key: 'init',
        value: function init() {
            var miniGalleryLength = $('.gallery').length,
                noGridGalleryLength = $('.js-no-grid').length;

            if (miniGalleryLength) {
                for (var i = miniGalleryLength; i--;) {
                    $('.gallery').eq(i).magnificPopup({
                        delegate: 'a',
                        type: 'image',
                        closeOnContentClick: true,
                        closeBtnInside: false,
                        fixedContentPos: true,
                        mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
                        image: {
                            verticalFit: true
                        },
                        tLoading: 'Ładuję...',
                        gallery: {
                            enabled: true,
                            tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
                        },
                        zoom: {
                            enabled: false,
                            duration: 300 // don't foget to change the duration also in CSS
                        }
                    });
                }
            }
        }
    }]);

    return MiniGallery;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\parallax.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Parallax = exports.Parallax = function () {
    function Parallax() {
        _classCallCheck(this, Parallax);
    }

    _createClass(Parallax, [{
        key: 'init',
        value: function init($sections) {
            if ($(window).width() > 1020) {
                $(window).scroll(function () {
                    var wScrollTop = $(window).scrollTop();
                    $('[data-parallax="true"]').each(function (id, item) {
                        if ($(this).visible(true)) {
                            var itemTop = $(this).offset().top;
                            var s = wScrollTop - itemTop;
                            $(this).find('.parallax-bg').css({
                                'transform': 'translateY(' + s * 0.3 + 'px)',
                                '-webkit-transform': 'translateY(' + s * 0.3 + 'px)',
                                '-moz-transform': 'translateY(' + s * 0.3 + 'px)'
                            });
                        }
                    });
                });
            }
        }
    }]);

    return Parallax;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\scrollTo.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollTo = exports.ScrollTo = function () {
	function ScrollTo() {
		_classCallCheck(this, ScrollTo);
	}

	_createClass(ScrollTo, [{
		key: 'init',
		value: function init() {
			$('.scroll-to a, .features-list--about-menu a').on('click', function (e) {
				e.preventDefault();
				var distElement = $(this).attr('href'),
				    distElementTop = $(distElement).offset().top;

				$('html, body').animate({
					scrollTop: distElementTop
				}, 500);
			});

			$('body').scrollspy({ target: '#about-menu' });
		}
	}]);

	return ScrollTo;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\sidePanel.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SidePanel = exports.SidePanel = function () {
	function SidePanel() {
		_classCallCheck(this, SidePanel);
	}

	_createClass(SidePanel, [{
		key: 'init',
		value: function init() {
			if ((typeof sidePanelOptions === 'undefined' ? 'undefined' : _typeof(sidePanelOptions)) == 'object') {
				var self = this,
				    cookieFlag = self.getCookie('side-panel-' + sidePanelOptions.siteId),
				    currentCookie = cookieFlag != null ? JSON.parse(cookieFlag) : null,
				    body = $('body');

				$(document).ready(function () {
					if (currentCookie == null || currentCookie.id != sidePanelOptions.id) {
						sidePanelOptions.closed = 0;
						self.setCookie('side-panel-' + sidePanelOptions.siteId, JSON.stringify(sidePanelOptions), 365);
						self.checkRevealType();
					} else {
						if (currentCookie.closed == 0 && sidePanelOptions.reactive == 0 || currentCookie.closed == 1 && currentCookie.reactive == 0 && sidePanelOptions.reactive == 1) {
							self.checkRevealType();
						}
					}

					body.on('click', '.side-panel__close', function () {
						self.hidePanel();
					});
					body.on('click', '.side-panel.close', function () {
						self.reopenPanel();
					});
				});
			}
		}
	}, {
		key: 'reopenPanel',
		value: function reopenPanel() {
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('close').addClass('open').fadeIn();
			});
		}
	}, {
		key: 'showPanel',
		value: function showPanel() {
			$('.side-panel').fadeIn(function () {
				$(this).removeClass('close').addClass('open');
			});
		}
	}, {
		key: 'hidePanel',
		value: function hidePanel() {
			var self = this;
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('open').addClass('close').show();
			});
			var cookie = self.getCookie('side-panel-' + sidePanelOptions.siteId);
			var parsedCookie = JSON.parse(cookie);

			parsedCookie.closed = 1;
			sidePanelOptions.reactive == 1 ? parsedCookie.reactive = 1 : parsedCookie.reactive = 0;
			self.setCookie('side-panel-' + sidePanelOptions.siteId, JSON.stringify(parsedCookie), 365);
		}
	}, {
		key: 'showAfterTime',
		value: function showAfterTime(time) {
			var self = this;
			var delay = parseInt(time) * 1000;
			setTimeout(function () {
				self.showPanel();
			}, delay);
		}
	}, {
		key: 'showAfterDistance',
		value: function showAfterDistance(distance) {
			var self = this,
			    notClosed = true;
			$(window).scroll(function () {
				var st = $(window).scrollTop();

				if (st > distance && notClosed) {
					self.showPanel();
					notClosed = false;
				}
			});
		}
	}, {
		key: 'checkRevealType',
		value: function checkRevealType() {
			var self = this;

			if (sidePanelOptions.distance != 0) {
				self.showAfterDistance(sidePanelOptions.distance);
			} else if (sidePanelOptions.time != 0) {
				self.showAfterTime(sidePanelOptions.time);
			}
		}
	}, {
		key: 'getCookie',
		value: function getCookie(name) {
			var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
			return v ? v[2] : null;
		}
	}, {
		key: 'setCookie',
		value: function setCookie(name, value, days) {
			var d = new Date();
			d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
			document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
		}
	}]);

	return SidePanel;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\svgInjector.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SvgInjector = exports.SvgInjector = function () {
	function SvgInjector() {
		_classCallCheck(this, SvgInjector);
	}

	_createClass(SvgInjector, [{
		key: 'init',
		value: function init() {
			var mySVGsToInject = document.querySelectorAll('img.inject-svg');
			SVGInjector(mySVGsToInject, {}, function () {
				$('.contact-map--transparent path').hover(function () {
					var pathID = $(this).attr('id');
					$('.contact-map--color path[id="' + pathID + '"]').css({ 'fill': '#003179' });
				}, function () {
					$('.contact-map--color path').css({ 'fill': 'rgb(210, 220, 237)' });
				});

				$('.contact-map--transparent path').on('click', function () {
					$('.map-infos').hide();
					var tabID = $(this).attr('id');
					$('.contact-map--color path').attr('class', 'swisspor-area');
					$('.contact-map--color path[id="' + tabID + '"]').attr('class', 'swisspor-area active');
					$('.map-item').hide();
					$('.map-item[data-tab="' + tabID + '"]').show();
				});

				$('.js--regions').on('click', function () {
					$(this).closest('.map-item__regions').find('.regions-list').slideToggle();
				});
			});
		}
	}]);

	return SvgInjector;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\switches.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Switches = exports.Switches = function () {
	function Switches() {
		_classCallCheck(this, Switches);
	}

	_createClass(Switches, [{
		key: 'init',
		value: function init() {
			$('.features-list--switch a').on('click', function (e) {
				e.preventDefault();

				var href = $(this).attr('href');

				$(this).closest('.section').fadeOut(function () {
					$(href).fadeIn();
				});
			});
		}
	}]);

	return Switches;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\validator.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validator = exports.Validator = function () {
	function Validator() {
		_classCallCheck(this, Validator);
	}

	_createClass(Validator, [{
		key: 'init',
		value: function init() {
			if ((typeof contactFormRules === 'undefined' ? 'undefined' : _typeof(contactFormRules)) == 'object') {
				$('#contactForm').validate({
					rules: contactFormRules,
					errorPlacement: function errorPlacement(error, element) {},
					submitHandler: function submitHandler(text) {
						$.ajax({
							url: $('#contactForm').attr("action"),
							method: 'POST',
							data: $('#contactForm').serialize(),
							beforeSend: function beforeSend() {
								$('#contactForm').find('button').prop('disabled', 'disabled');
							},
							success: function success() {
								$('#contactForm').find('input, textarea').val('');
								$('#contactForm').fadeOut(500, function () {
									$('#contactForm').replaceWith('<div class="form__message form__message--success">Wiadomość została wysłana. Dziękujemy.</div>').fadeIn(500);
								});
							},
							error: function error() {
								$('#contactForm').find('input, textarea').val('');
								$('#contactForm').fadeOut(500, function () {
									$('#contactForm').replaceWith('<div class="form__message form__message--error">Wiadomość nie została wysłana. Prosimy spróbować później.</div>').fadeIn(500);
								});
							}
						});
					}
				});
			}
		}
	}]);

	return Validator;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\video.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Video = exports.Video = function () {
	function Video() {
		_classCallCheck(this, Video);
	}

	_createClass(Video, [{
		key: 'init',
		value: function init() {
			var self = this;
			$('.video-player').hover(function (e) {
				e.preventDefault();
				var $this = $(this);
				self.play($this);
			}, function (e) {
				e.preventDefault();
				var $this = $(this);
				self.stop($this);
			});
		}
	}, {
		key: 'play',
		value: function play(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.play();
			}
		}
	}, {
		key: 'stop',
		value: function stop(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.pause();
			}
		}
	}]);

	return Video;
}();

},{}],"C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\modules\\visible.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Visible = exports.Visible = function () {
	function Visible() {
		_classCallCheck(this, Visible);
	}

	_createClass(Visible, [{
		key: 'init',
		value: function init() {

			var elem = $('.features-list__item, .features-list__content');
			var self = this;

			self.checkIfVisible(elem);

			$(window).scroll(function () {
				self.checkIfVisible(elem);
			});
			this.delayShort($('.features-list--homepage-bands .features-list__item'));
			// this.delayShort($('.form--newsletter > *'));
		}
	}, {
		key: 'checkIfVisible',
		value: function checkIfVisible(elem) {
			elem.each(function () {
				var $this = $(this),
				    elemVisible = $this.visible(true, 'vertical');

				if (elemVisible) {
					$this.addClass('on-screen', elemVisible);
					// if($this.hasClass('features-list__content')){
					// 	setTimeout(function() {
					// 		$this.addClass('flipped', elemVisible);
					// 	}, 1000);
					// }
					setTimeout(function () {
						$this.addClass('triggered');
					}, 500);
				}
			});
		}
	}, {
		key: 'delay',
		value: function delay(elem) {
			elem.each(function (index) {
				$(this).css('transition-delay', 300 + 150 * index + 'ms');
			});
		}
	}, {
		key: 'delayShort',
		value: function delayShort(elem) {
			elem.each(function (index) {
				$(this).css('transition-delay', 50 * index + 'ms');
			});
		}
	}, {
		key: 'delayShortWithClick',
		value: function delayShortWithClick(elem) {
			elem.each(function (index) {
				$(this).css('transition-delay', 100 * index + 'ms');
			});
		}
	}]);

	return Visible;
}();

},{}]},{},["C:\\xampp\\htdocs\\mystic-festival\\www\\2019\\resources\\assets\\scripts\\src\\main.js"])

